import { FormNames } from '../../../containers/Form/CreateReservation'
import { ICreateReservationFormValues } from '../../../containers/Form/CreateReservation/CreateReservation'
import { ReservationModalActions } from '../../../reducers/bookingCalendar/actionNames'

export interface IReservationFormChange {
  values: Partial<ICreateReservationFormValues>
  prevValues: Partial<ICreateReservationFormValues>
  formName: FormNames
  type: ReservationModalActions
}

const onReservationFormChange = (
  values,
  prevValues,
  formName,
): IReservationFormChange => ({
  formName,
  prevValues,
  type: ReservationModalActions.OnChange,
  values,
})

export default onReservationFormChange
